import React from "react";
import _ from "lodash";

// import { getFieldsReport, getFieldsReportForm } from "../../appFormReportsUtility";
import { getFieldsReportForm } from "../../../sims/appFormReportsUtility";

import moment from "moment";
const reportData = [
  {
    sname: "ROW 1",
    rname: "MDR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "1XR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "XGPR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "GPXR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "FR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "TAM-3NBAR ",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "MDR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "MDR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
  {
    sname: "ROW 1",
    rname: "MDR",
    sno: "1717087",
    test: "C",
    rtype: "ST (400004 / 400004)",
    resis: "500",
    cont: "4FB-2F-1B",
    tdate: "02/09/2021",
    drop: "0.0053 A DC",
    pick: "0.0104 A DC",
    work: "0.0104 A DC",
  },
];

const relayForms = ["CP_FRA234_263And236_106", "FRA234_263And236_106", "CN_10Y_FRA236_267And236_108", "2YearRelayTest", "4YearRelayTest"];
export const relayReport = (relaysData) => {
  let data = {};
  relaysData &&
    relaysData.map((relayData) => {
      let childForms = relayData.childForms ? relayData.childForms : [];
      if (childForms && childForms.length > 0) {
        let dataArray = [];
        for (let form of relayForms) {
          dataArray = getFieldsReportForm(childForms, form, "parentTestCode");
          if (dataArray.length != 0) {
            if (!data[form]) data[form] = [];
            data[form] = [...data[form], ...dataArray];
            break;
          }
        }
      }
    });

  function getRelayData(data) {
    return (
      data &&
      data.map((data) => {
        return (
          <tbody>
            <tr>
              <td colSpan={3}>
                <strong>Shelf Name</strong>
                <br />
                <div>{data.sname}</div>
              </td>
              <td colSpan={3}>
                <strong>Relay Name</strong>
                <br />
                <div>{data.rname}</div>
              </td>
              <td colSpan={3}>
                <strong>Serial Number</strong>
                <br />
                <div>{data.sno}</div>
              </td>
              <td colSpan={3}>
                <strong>Condition Left</strong>
                <br />
                <div>{data.test}</div>
              </td>
            </tr>
            <tr>
              <td colSpan={6}>
                <strong>Relay Type (Drawing and/or Catalog Number)</strong>
                <br />
                <div>{data.rtype}</div>
              </td>
              <td colSpan={2}>
                <strong>Resistance (Ohms)</strong>
                <br />
                <div>{data.resis}</div>
              </td>
              <td colSpan={3}>
                <strong>Contacts </strong>
                <br />
                <div>{data.cont}</div>
              </td>
              <td colSpan={1}>
                <strong>Date Tested</strong>
                <br />
                <div>{data && data.tdate && moment(data.tdate).format("MM-DD-YYYY")}</div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                <strong>Neutral Dropaway</strong>
                <br />
                <div>{data.drop}</div>
              </td>
              <td colSpan={2}>
                <strong>Neutral Pickup </strong>
                <br />
                <div>{data.pick}</div>
              </td>
              <td colSpan={2}>
                <strong>Neutral Working</strong>
                <br />
                <div>{data.work}</div>
              </td>
              <td colSpan={6}>
                <strong>Comments</strong>
                <br />
                <div>{data.com}</div>
              </td>
            </tr>
          </tbody>
        );
      })
    );
  }

  function getNewRelayData(data) {
    return (
      data &&
      data.map((data) => {
        let dateTested = data.testSched && data.testSched.date && moment(data.testSched.date).format("MM-DD-YYYY");
        let dateEntered =
          (data.testSched &&
            data.testSched.backdate &&
            data.testSched.backdate.originalDate &&
            moment(data.testSched.backdate.originalDate).format("MM-DD-YYYY")) ||
          dateTested;

        return (
          <tbody>
            <tr>
              <td colSpan={3}>
                <strong>Shelf Name</strong>
                <br />
                <div>{data.sname}</div>
              </td>
              <td colSpan={3}>
                <strong>Relay Name</strong>
                <br />
                <div>{data.rname}</div>
              </td>
              <td colSpan={3}>
                <strong>Serial Number</strong>
                <br />
                <div>{data.sno}</div>
              </td>
              <td colSpan={3}>
                <strong>Condition Left</strong>
                <br />
                <div>{data.test}</div>
              </td>
            </tr>
            <tr>
              <td colSpan={3}>
                <strong>Relay Type</strong>
                <br />
                <div>{data.rtype}</div>
              </td>
              <td colSpan={3}>
                <strong>Drawing Number</strong>
                <br />
                <div>{data.dnumb}</div>
              </td>
              <td colSpan={3}>
                <strong>Resistance (Ohms)</strong>
                <br />
                <div>{data.resis}</div>
              </td>
              <td colSpan={3}>
                <strong>Contacts </strong>
                <br />
                <div>{data.cont}</div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                <strong>Shop Dropaway</strong>
                <br />
                <div>{data.drop}</div>
              </td>
              <td colSpan={2}>
                <strong>Field Dropaway</strong>
                <br />
                <div>{data.fdrop}</div>
              </td>
              <td colSpan={2}>
                <strong>Shop Pickup </strong>
                <br />
                <div>{data.pick}</div>
              </td>
              <td colSpan={2}>
                <strong>Field Pickup </strong>
                <br />
                <div>{data.fpick}</div>
              </td>
              <td colSpan={2}>
                <strong>Shop Working</strong>
                <br />
                <div>{data.work}</div>
              </td>
              <td colSpan={2}>
                <strong>Field Working</strong>
                <br />
                <div>{data.fwork}</div>
              </td>
            </tr>

            <tr>
              <td colSpan={2}>
                <strong>Inspector Name</strong>
                <br />
                <div>{data.iname}</div>
              </td>
              <td colSpan={2}>
                <strong>Date Tested</strong>
                <br />
                <div>{dateTested}</div>
              </td>
              <td colSpan={2}>
                <strong>Date Entered</strong>
                <br />
                <div>{dateEntered}</div>
              </td>
              <td colSpan={6}>
                <strong>Comments</strong>
                <br />
                <div>{data.com}</div>
              </td>
            </tr>
          </tbody>
        );
      })
    );
  }

  return Object.keys(data).map((key) => {
    let relayData = ["2YearRelayTest", "4YearRelayTest"].includes(key) ? getNewRelayData(data[key]) : getRelayData(data[key]);
    let title = {
      default: "Relay Tests (FRA 234.263, 236.106)",
      "2YearRelayTest": "2 Year Relay Tests",
      "4YearRelayTest": "4 Year Relay Tests",
    };
    let reportClassName = title[key] ? "table table-bordered new-relay" : "table table-bordered";

    return (
      <div className=".table-scroll">
        <table className={reportClassName}>
          <thead>
            <tr>
              <th colSpan={12}>
                <h2>{title[key] || title.default}</h2>
              </th>
            </tr>
          </thead>
          {relayData}
          {addEmptyColsIfNotEnough(relayData, 11, key)}
        </table>
      </div>
    );
  });
};

function addEmptyColsIfNotEnough(mapArray, minRows, key) {
  let emptyRows = null;
  let grpRows = [];
  let countToAdd = minRows - mapArray.length;
  let newRelayCheck = ["2YearRelayTest", "4YearRelayTest"].includes(key);
  let typeToAdd = newRelayCheck ? ["rone", "rtwo", "rthree", "rfour"] : ["one", "two", "three"];
  let rowCount = newRelayCheck ? 3 : 2;
  if (countToAdd > 0) {
    emptyRows = [];
    let count = 0;
    for (let i = 0; i < countToAdd; i++) {
      let row = <tr key={`tr-${i}`}>{getCols(typeToAdd[count])}</tr>;
      grpRows.push(row);
      if (count < rowCount) {
        count++;
      } else {
        emptyRows.push(<tbody key={`tbody-${count}${i}`}>{grpRows}</tbody>);
        count = 0;
        grpRows = [];
      }
    }
  }
  return emptyRows;
}
function getCols(type) {
  let cols = [];
  let span = [];
  let typeKey = {
    one: [3, 3, 3, 3],
    two: [6, 2, 3, 1],
    three: [2, 2, 2, 6],
    rone: [3, 3, 3, 3],
    rtwo: [6, 2, 3, 1],
    rthree: [2, 2, 2, 2, 2, 2],
    rfour: [12],
  };
  span = typeKey[type];
  for (let i = 0; i < span.length; i++) {
    cols.push(<td colSpan={span[i]} key={`td-${i}`}></td>);
  }
  return cols;
}



// WEBPACK FOOTER //
// ./src/components/Reports/CP/NewCrossingReport/ReportSections/relayReport.jsx